// 'Build app' — the AI surfaces' EXPLICIT build mode.
//
// v2 (2026-09-02 per Nika "buld app should not open /add-app section but
// should be toggle which runs this functionality and opens that generated
// page after output"): the '+' menu row ARMS root._aiBuildMode instead of
// navigating. While armed, a send from EITHER AI surface routes into the
// addapp-scoped build pipeline from wherever the user is — the canvas
// composer branches in its own _sendPrompt (its normal path is
// freestyleSend, a different transport), and the sidebar rides the scope
// flip in functions/_simone/sendPrompt.js — and `watchAiBuildOutput`
// opens the build surface in a pane once the output lands, so
// the user sees the generated page without leaving their screen
// mid-build.
//
// forceBuildApp(draft) stays the single entry: send the draft into the
// addapp thread headlessly + arm the completion watcher.
export const forceBuildApp = function (draft, attachments, attached) {
  const root = this.state && this.state.root
  if (!root || !root.update) return
  const text = String(draft || '').trim()
  if (!text) return
  try {
    this.call('sendPrompt', text, 'addapp', attachments, attached)
  } catch (err) {
    console.warn('[buildApp] send failed:', err && err.message)
    return
  }
  this.call('watchAiBuildOutput')
}

// Bounded completion watcher — ONE at a time (re-arming resets the clock).
// The addapp turn's liveness signal is `_ax_chatTyping`; when it settles
// false after having been true, open a pane without routing away.
// Capture only root state: the initiating composer may have unmounted.
// Stop after five minutes; slower builds remain available to open manually.
export const watchAiBuildOutput = function () {
  const root = this.state && this.state.root
  if (!root || !root.update) return
  if (root.__aiBuildWatch) clearInterval(root.__aiBuildWatch)
  const t0 = Date.now()
  let sawTyping = false
  root.__aiBuildWatch = setInterval(() => {
    const typing = !!root._ax_chatTyping
    if (typing) sawTyping = true
    if (sawTyping && !typing) {
      clearInterval(root.__aiBuildWatch)
      root.__aiBuildWatch = null
      // ON THE HOME the Build tab IS the builder (functions/homeBuild.js;
      // Nika 2026-10-23: "build tab should reuse ui/ux of /add-apps"): the
      // output is in it, so the tab comes to the front — never a second
      // builder in a pane over the home.
      const fns = (this.context && this.context.functions) || {}
      if (
        typeof fns.homeTabsOnScreen === 'function' &&
        typeof fns.homeViewSelect === 'function' &&
        this.call('homeTabsOnScreen', root)
      ) {
        this.call('homeViewSelect', 'build')
        return
      }
      if (!root._canvasSlot) {
        root.update({ _canvasSlot: '/add-app' }, { preventFetch: true })
      }
      return
    }
    if (Date.now() - t0 > 300000) {
      clearInterval(root.__aiBuildWatch)
      root.__aiBuildWatch = null
    }
  }, 1000)
}
